'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dDefaultable$0024given$005f$002dDefaultable$005f$002dString$0024 from "./dev.cheleb.scalamigen.-Defaultable$given_-Defaultable_-String$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00248 from "./dev.cheleb.scalamigen.-Form$$anon$8.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024given$005f$002dForm$005f$002dString$0024 from "./dev.cheleb.scalamigen.-Form$given_-Form_-String$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$31() {
}
export { $c_Lsamples_Persons$package$$anon$31 as $c_Lsamples_Persons$package$$anon$31 };
$p = $c_Lsamples_Persons$package$$anon$31.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$31;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$31() {
}
export { $h_Lsamples_Persons$package$$anon$31 as $h_Lsamples_Persons$package$$anon$31 };
$h_Lsamples_Persons$package$$anon$31.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024$0024anon$00248.$c_Ldev_cheleb_scalamigen_Form$$anon$8($j_dev$002echeleb$002escalamigen$002e$002dDefaultable$0024given$005f$002dDefaultable$005f$002dString$0024.$m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$(), $j_dev$002echeleb$002escalamigen$002e$002dForm$0024given$005f$002dForm$005f$002dString$0024.$m_Ldev_cheleb_scalamigen_Form$given\uff3fForm\uff3fString$());
});
var $d_Lsamples_Persons$package$$anon$31 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$31, "samples.Persons$package$$anon$31", ({
  pN: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$31 as $d_Lsamples_Persons$package$$anon$31 };
